export function applyChanges<ItemT>(existing: ItemT, changes: Partial<ItemT>, moreChanges?: Partial<ItemT>): ItemT {
  return Object.assign({}, existing, changes, moreChanges);
}
